import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'
import viAxiosError from './axios-error.vi.json'
import enAxiosError from './axios-error.en.json'

// Registers this module's `contract` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'contract', vi)
i18n.addResourceBundle('en', 'contract', en)

// Keep process API errors with this module; mutation handlers use the shared namespace.
i18n.addResourceBundle('vi', 'axios-error', viAxiosError, true, false)
i18n.addResourceBundle('en', 'axios-error', enAxiosError, true, false)
